


import { IQueryURL } from "../interface/util";

function parse(queryString: string): Record<string,string>  {
    let query: Record<string,string> = {};

    const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');

    for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].split('=');
        const k = decodeURIComponent(pair[0]);
        const v: any = decodeURIComponent(pair[1]) ?? '';
        query[k] = v;
    }
    return query;
}

function assemble(queryArgs: {}): string {
    let strPairs: Array<string> = [];

    for ( const key in queryArgs) {
        const value = (queryArgs as any)[key];
        const encodedStr = encodeURIComponent(key) + '=' + encodeURIComponent(value);
        strPairs.push(encodedStr);
    }

    return '?' + strPairs.join('&')
}

const exports: IQueryURL = {
    parse,
    assemble,
}

export default exports